module.exports = __webpack_public_path__ + "dca1af046e0c37bf693e59ea73c19913.fbx";